export default defineNuxtRouteMiddleware((to) => {
  const config = useRuntimeConfig()

  if (!config.public.maintenanceMode) {
    return
  }

  if (to.path.startsWith('/admin')) {
    return
  }

  const maintenanceAccess = useState('maintenance-access', () => false)

  if (import.meta.server) {
    const event = useRequestEvent()
    const forwardedIp = useRequestHeader('x-forwarded-for')?.split(',')[0]
    const requestIp = event?.context.clientAddress
      || useRequestHeader('x-real-ip')
      || forwardedIp
      || event?.node.req.socket.remoteAddress
    const configuredIps = Array.isArray(config.maintenanceAllowedIps)
      ? config.maintenanceAllowedIps
      : config.maintenanceAllowedIps.split(',')
    const normalizeIp = (ip: string) => ip.trim().toLowerCase().replace(/^::ffff:/, '')
    const normalizedRequestIp = requestIp ? normalizeIp(requestIp) : ''

    maintenanceAccess.value = configuredIps
      .map(ip => normalizeIp(String(ip)))
      .filter(Boolean)
      .includes(normalizedRequestIp)
  }

  if (maintenanceAccess.value) {
    return
  }

  throw createError({
    statusCode: 503,
    statusMessage: 'Maintenance',
    fatal: true
  })
})
